import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "py-2 shadow-3" }
const _hoisted_2 = { class: "container d-flex d-lg-none flex-column mb-2" }
const _hoisted_3 = { class: "container d-flex justify-content-around" }
const _hoisted_4 = { class: "col-lg-7 d-none d-lg-flex flex-row nowrap align-items-center" }
const _hoisted_5 = { class: "col-3 text-center px-0 heading text-grey-900" }
const _hoisted_6 = { class: "prestations-list col-7 d-flex flex-column px-2 align-items-start" }
const _hoisted_7 = { class: "col-2 text-center px-0" }
const _hoisted_8 = { class: "col-12 col-lg-5 px-0 d-flex flex-row nowrap justify-content-between" }
const _hoisted_9 = { class: "p-0 d-flex align-items-center justify-content-center justify-content-lg-end pe-2" }
const _hoisted_10 = { class: "col-5 col-sm-6 ps-md-0 text-center d-flex align-items-center justify-content-center" }
const _hoisted_11 = { class: "w-100 d-flex align-items-center justify-content-center" }
const _hoisted_12 = { class: "buttons-default px-3 px-md-1" }

import { computed, nextTick, onActivated, onBeforeUnmount, onMounted, onUpdated, ref, watch } from "vue";
import { useStore } from "vuex";
import Prices from "@/vue/planning/components/common/prices.vue"
import PricesPP from "@/vue/planning/components/common/pricesPP.vue"
import ParticipantsTotals from "@/vue/planning/components/common/participantsTotals.vue"
import { elementInViewport } from "@/utils/utils"
import pricesLoadingSet from "@/vue/planning/state/pricesLoadingSet"
import currentCacheKey from "@/vue/planning/computed/currentCacheKey"
import getReservationClickData from "@/tracking/logic/getReservationClickData"
import getSiteFromDomain from "@/vue/planning/logic/getSiteFromDomain"

// Tracking
import trackReservationClick from "@/tracking/trackReservationClick"

const speed = 250;


export default /*@__PURE__*/_defineComponent({
  __name: 'stickySummary',
  setup(__props) {

const store = useStore();

const stickySummary = ref<HTMLElement | null>(null);
let scrollListener: (() => void) | null = null;
let throttleTimer: ReturnType<typeof window.setTimeout> | null = null;
const isListenerActive = ref(false);

// if there is no product available, don't show the summary
const hideStickySummary = computed(() => {
	return Object.keys(store.getters.wiypCall).length === 0;
});

const content = computed(() => store.state.content);
const participants = computed(() => store.state.participants);

const totalSelectedHebergements = computed<number>(() => store.getters.totalSelectedHebergements);
const totals = computed(() => store.getters.totals);
const selectedPrestations = computed(() => store.getters.selectedPrestations);
const locale = computed(() => store.getters.locale);

const checkIfPerPersonDisplayWebsite = computed(() => {
	return ["www.uk.travelski.com","www.nl.travelski.com"].includes(getSiteFromDomain(window.location.hostname));
});

function fadeIn(display = "block") {
	const el = stickySummary.value;
	if (!el) return;
	el.style.opacity = "0";
	el.style.display = display;
	nextTick(() => {
		const el2 = stickySummary.value;
		if (!el2) return;
		el2.style.opacity = "1";
	});
}

function fadeOut() {
	const el = stickySummary.value;
	if (!el) return;

	el.style.opacity = "0";
	window.setTimeout(() => {
		const el2 = stickySummary.value;
		if (!el2) return;
		el2.style.display = "none";
	}, speed);
}

function handleReserveClick() {
	store.dispatch("reserveClick");

	const {
		quantity,
		liheId,
		liheName,
		duration,
		beginDate,
		endDate,
		prestationsIds,
		prestationsNames,
		totalPrice,
		station,
		region,
	} = getReservationClickData();

	const normalizedTotalPrice =
		typeof totalPrice === "string" ? Number(totalPrice) : totalPrice;

	trackReservationClick(
		"book",
		quantity,
		prestationsIds,
		prestationsNames,
		normalizedTotalPrice,
		beginDate,
		endDate,
		duration,
		liheId,
		liheName,
		station,
		region
	);
}

function cleanupScrollListener() {
	isListenerActive.value = false;

	if (scrollListener) {
		try {
			window.removeEventListener("scroll", scrollListener);
		} catch (e) {
			console.warn("[StickySummary] Error removing listener:", e);
		}
		scrollListener = null;
	}

	if (throttleTimer) {
		window.clearTimeout(throttleTimer);
		throttleTimer = null;
	}
}

function activateScrollListener() {
	// Remove existing listener if any to prevent duplicates
	cleanupScrollListener();

	const throttledScrollListener = () => {
		// Throttle: if timer is running, skip this event
		if (throttleTimer) return;

		const el = stickySummary.value;
		if (!el) return;

		const summary = document.querySelector("#summary");
		const footer = document.querySelector("footer");
		const summaryInView = !!summary && elementInViewport(summary as Element);
		const footerInView = !!footer && elementInViewport(footer as Element);

		if (summaryInView || footerInView) {
			if (el.style.display !== "none") fadeOut();
		} else {
			if (el.style.display === "none") {
				if (totalSelectedHebergements.value === 0) return;
				fadeIn();
			}
		}

		throttleTimer = window.setTimeout(() => {
			throttleTimer = null;
		}, 50);
	};

	scrollListener = throttledScrollListener;

	try {
		window.addEventListener("scroll", scrollListener, { passive: true });
		isListenerActive.value = true;
	} catch (e) {
		console.error("[StickySummary] Error activating scroll listener:", e);
		isListenerActive.value = false;
	}
}

function decideShowOrHideStickySummary(newValue: number, oldValue: number) {
	if (newValue > 0 && oldValue === 0) {
		// Always fadeIn, let scroll handler hide if needed
		fadeIn();
	} else if (newValue === 0 && oldValue > 0) {
		fadeOut();
	}
}

watch(totalSelectedHebergements, (newValue, oldValue) => {
	decideShowOrHideStickySummary(newValue, oldValue);
});

onMounted(() => {
	if (totalSelectedHebergements.value) fadeIn();
	nextTick(() => {
		activateScrollListener();
	});
});

onUpdated(() => {
	if (stickySummary.value && (!isListenerActive.value || !scrollListener)) {
		nextTick(() => {
			if (!isListenerActive.value) activateScrollListener();
		});
	}
});

onActivated(() => {
	if (!isListenerActive.value) {
		nextTick(() => {
			activateScrollListener();
		});
	}
});

onBeforeUnmount(() => {
	cleanupScrollListener();
});

return (_ctx: any,_cache: any) => {
  return (!hideStickySummary.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "sticky-summary bg-white",
        id: "sticky-summary",
        style: {"display":"none","opacity":"0"},
        ref_key: "stickySummary",
        ref: stickySummary
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedPrestations.value, (prest, prest_i) => {
              return (_openBlock(), _createElementBlock("span", {
                class: "1",
                key: prest_i
              }, [
                _createElementVNode("strong", null, _toDisplayString(prest.quantity) + " x ", 1),
                _createTextVNode(_toDisplayString(prest.prestation.prestName), 1)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(content.value.planningSummary_yourSelection), 1),
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedPrestations.value, (prest, prest_i) => {
                  return (_openBlock(), _createElementBlock("span", {
                    class: "text-start body text-grey-900",
                    key: prest_i
                  }, _toDisplayString(prest.quantity) + " x " + _toDisplayString(prest.prestation.prestName), 1))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(ParticipantsTotals, {
                  participants: participants.value,
                  content: content.value,
                  additionalClasses: 'body text-grey-900'
                }, null, 8, ["participants", "content"])
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(checkIfPerPersonDisplayWebsite.value ? PricesPP : Prices), {
                  isLoading: _unref(pricesLoadingSet).has(_unref(currentCacheKey)),
                  crossedPrice: totals.value.crossedPrice,
                  totalPrice: totals.value.totalPrice,
                  perPrice: totals.value.perPrice,
                  maxPromo: totals.value.maxPromo,
                  locale: locale.value,
                  totalParticipants: participants.value.length
                }, null, 8, ["isLoading", "crossedPrice", "totalPrice", "perPrice", "maxPromo", "locale", "totalParticipants"]))
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("button", {
                    onClick: _withModifiers(handleReserveClick, ["stop"]),
                    class: "button-primary primary-normal w-100 d-flex flex-row nowrap align-items-center justify-content-center"
                  }, [
                    _createElementVNode("span", _hoisted_12, _toDisplayString(content.value.planner_resumeOrder), 1)
                  ])
                ])
              ])
            ])
          ])
        ])
      ], 512))
    : _createCommentVNode("", true)
}
}

})